import styled from 'styled-components';
import { Text, TextProps } from '@mantine/core';
import type { ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';
import { blockStrokeWidth } from '@dealstack/frontend/shared/lib/BlockTable/BlockLink/block-shared.ts';
import {
	innerBorderWidth,
	innermostRadius,
	nodeDiameter,
} from '@dealstack/frontend/shared/lib/BlockTable/BlockLink/innerBorderWidth.tsx';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);

export const NodeWrapper = styled.div<{ $color: string }>`
	box-sizing: border-box;
	position: relative;

	/* Line segment extending downwards */
	&::before {
		content: '';
		position: absolute;
		width: 1px;
		background-color: ${(props) => props.$color};
		left: 50%;
		transform: translateX(-50%);
		top: -2500px;
		bottom: -2500px;
		z-index: 0;
	}
`;

export const InnerRing = styled.div<{ color: string; $allowContextMenu?: boolean }>`
	width: ${nodeDiameter}px;
	height: ${nodeDiameter}px;
	border-radius: 50%;
	border: ${innerBorderWidth}px solid ${(props) => props.color};
	background-color: white;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	z-index: 1;

	${({ $allowContextMenu, theme }) =>
		$allowContextMenu
			? `
			overflow: hidden;
				transition: all ease-in-out 150ms;

				::after {
				opacity: 0;
		content: '⋯';
		position: absolute;
		background-color: white;
		font-weight: 800;
		transition: all ease-in-out 100ms;
				}

	:hover, .active {
		border-color: ${theme.v3.colors.gray[4]};

		::after {
			opacity: 1;
			cursor: pointer;
		}
	}
			`
			: ''}
`;

export const InnermostCircle = styled.div<{ color: string }>`
	width: ${innermostRadius * 2}px;
	height: ${innermostRadius * 2}px;
	border-radius: 50%;
	background-color: ${(props) => props.color};
`;

export const FloatingLabel = styled(PlainText)<TextProps>`
	position: absolute;
	top: 0;
	left: calc(100% + 0.25rem);
	white-space: nowrap;
`;

export const StyledBlockLinkContainer = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	width: 100%;
	justify-content: space-between;
`;

export const BlockLinkLine = styled.div<{ color: string }>`
	background: ${(props) => props.color};
	width: 100%;
	height: ${blockStrokeWidth}px;
`;

export const ElementWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
	position: relative;
`;

export const AbsoluteCenterWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
	min-width: 50%;
`;
